export default __webpack_public_path__ + "static/media/tasks.6f9fde7d.svg";